/**
 * /operations/tickets-agent — Travel Tickets agent (Pack 17 v2).
 */
import { PageHeader } from "../components/ui";
import { AgentBadge } from "../components/ui/AgentBadge";

export function TravelTicketsAgentPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Travel Tickets Agent"
        subtitle="Mutaba'aa tracks Article 40 entitlement; Tashghil drives the ticket workflow."
      />
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3"><AgentBadge agent="mutabaa" /><h3 className="text-base font-semibold">Mutaba'aa — Article 40</h3></div>
        <p className="text-sm text-text-secondary">Expat repatriation ticket vests at 1yr service. Mutaba'aa tracks vesting + emits TicketEntitlementVested events.</p>
      </section>
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3"><AgentBadge agent="tashghil" /><h3 className="text-base font-semibold">Tashghil — workflow</h3></div>
        <ul className="text-sm text-text-secondary space-y-1.5">
          <li>Annual home-leave ticket workflow</li>
          <li>Repatriation-EOS ticket on termination</li>
          <li>Emergency ticket routing</li>
        </ul>
      </section>
    </div>
  );
}
